<!-- ========================================== -->
<!-- 1. HALAMAN DAFTAR LOWONGAN (LIST VIEW)     -->
<!-- ========================================== -->
<div *ngIf="!currentJobDetail">
    <!-- Career Hero Section -->
    <section
        class="relative bg-gradient-to-b from-[#102B51] via-[#163564] to-[#0D2240] text-white py-16 md:py-24 overflow-hidden">
        <!-- Decorative Ambient Glows -->
        <div class="absolute -top-24 -left-24 w-96 h-96 bg-emerald-500/20 rounded-full blur-3xl pointer-events-none">
        </div>
        <div class="absolute top-1/2 -right-24 w-96 h-96 bg-cyan-500/20 rounded-full blur-3xl pointer-events-none">
        </div>

        <!-- Craftybyul Mascot Decoration (Desktop) -->
        <div
            class="hidden lg:block absolute right-8 bottom-0 w-64 xl:w-80 pointer-events-none select-none opacity-90 transition-transform duration-500 hover:scale-105">
            <img src="/assets/visidea/craftybyul_1.png" alt="Visidea Mascot" class="w-full h-auto drop-shadow-2xl">
        </div>

        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
            <div class="max-w-3xl mx-auto text-center space-y-6">
                <!-- Main Heading inspired by GoTo reference -->
                <div class="space-y-2">
                    <h1
                        class="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight text-white leading-tight">
                        Temukan Peluang <span class="text-emerald-400">Karier Anda</span>
                    </h1>
                    <h2 class="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-200 leading-snug">
                        Telusuri Beragam Pilihan Karier di Visidea Studio
                    </h2>
                </div>

                <!-- Subtitle -->
                <p class="text-gray-300 text-sm md:text-base lg:text-lg leading-relaxed max-w-2xl mx-auto">
                    Bergabunglah dengan kami di Visidea Studio dan buka potensi Anda, bekerja dengan tim yang
                    bersemangat, dan buat perbedaan nyata di industri event & visual modern. Kami dengan antusias
                    menantikan kedatangan Anda!
                </p>

                <!-- CTA Buttons (Solid Hijau & Biru) -->
                <div class="pt-2 flex flex-wrap items-center justify-center gap-4">
                    <button (click)="scrollToJobs()"
                        class="inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-sm md:text-base shadow-md hover:shadow-lg transition-all duration-200 transform hover:-translate-y-0.5 cursor-pointer">
                        <span>Lihat Lowongan Tersedia</span>
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
                        </svg>
                    </button>
                    <a href="https://wa.me/{{whatsappNumber}}?text=Halo%20Visidea%20Studio,%20saya%20tertarik%20mengenai%20informasi%20karier%20dan%20rekrutmen%20Visidea.%20Bisa%20dibantu%20informasinya?%20Terima%20kasih!"
                        target="_blank"
                        class="inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-[#102B51] hover:bg-[#163564] text-white border border-white/20 font-semibold text-sm md:text-base shadow-md transition-all duration-200 cursor-pointer">
                        <img src="/assets/visidea/whatsapp.png" class="w-4 h-4 brightness-0 invert" alt="WhatsApp">
                        <span>Tanya via WhatsApp</span>
                    </a>
                </div>
            </div>
        </div>
    </section>

    <!-- Job Listings Section with Search & Filter (Inspired by GoTo Layout) -->
    <section id="job-listings-section" class="py-12 md:py-20 bg-white">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <!-- Search and Filter Bar -->
            <div class="bg-white rounded-2xl shadow-sm border border-gray-200 p-4 sm:p-5 mb-8">
                <div class="grid grid-cols-1 md:grid-cols-12 gap-3 sm:gap-4 items-center">
                    <!-- Search Box -->
                    <div class="md:col-span-6 relative">
                        <div class="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                            <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                            </svg>
                        </div>
                        <input type="text" [(ngModel)]="searchQuery"
                            placeholder="Cari Pekerjaan, Posisi, atau Kata Kunci..."
                            class="w-full pl-11 pr-4 py-3 bg-gray-50 hover:bg-gray-100/70 focus:bg-white text-gray-800 placeholder-gray-400 rounded-xl border border-gray-200 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-200 outline-none transition-all text-sm md:text-base">
                    </div>

                    <!-- Department Filter -->
                    <div class="md:col-span-3">
                        <div class="relative">
                            <select [(ngModel)]="selectedDepartment"
                                class="w-full py-3 pl-4 pr-10 bg-gray-50 hover:bg-gray-100/70 focus:bg-white text-gray-800 font-medium rounded-xl border border-gray-200 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-200 outline-none transition-all text-sm md:text-base appearance-none cursor-pointer">
                                <option *ngFor="let dept of departments" [value]="dept.id">{{ dept.name }}</option>
                            </select>
                            <div
                                class="absolute inset-y-0 right-0 flex items-center px-3 pointer-events-none text-gray-500">
                                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M19 9l-7 7-7-7"></path>
                                </svg>
                            </div>
                        </div>
                    </div>

                    <!-- Location Filter -->
                    <div class="md:col-span-3">
                        <div class="relative">
                            <select [(ngModel)]="selectedLocation"
                                class="w-full py-3 pl-4 pr-10 bg-gray-50 hover:bg-gray-100/70 focus:bg-white text-gray-800 font-medium rounded-xl border border-gray-200 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-200 outline-none transition-all text-sm md:text-base appearance-none cursor-pointer">
                                <option *ngFor="let loc of locations" [value]="loc.id">{{ loc.name }}</option>
                            </select>
                            <div
                                class="absolute inset-y-0 right-0 flex items-center px-3 pointer-events-none text-gray-500">
                                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M19 9l-7 7-7-7"></path>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Job Count Indicator matching GoTo design -->
            <div class="flex items-center justify-between mb-6 pb-2 border-b border-gray-100">
                <p class="text-sm md:text-base text-gray-700">
                    <span class="font-extrabold text-[#102B51]">{{ filteredJobs.length }} pekerjaan</span>
                    tersedia di <span class="font-semibold text-emerald-800">{{ currentDepartmentLabel }}</span>
                    dan di <span class="font-semibold text-emerald-800">{{ currentLocationLabel }}</span>
                </p>
                <button *ngIf="selectedDepartment !== 'all' || selectedLocation !== 'all' || searchQuery"
                    (click)="selectedDepartment = 'all'; selectedLocation = 'all'; searchQuery = ''"
                    class="text-xs md:text-sm font-semibold text-emerald-600 hover:text-emerald-800 hover:underline cursor-pointer">
                    Reset Filter
                </button>
            </div>

            <!-- Job List (Clean Rows matching GoTo: No button, row click navigates to detail) -->
            <div class="divide-y divide-gray-200">
                <div *ngFor="let job of filteredJobs" (click)="goToJobDetail(job)"
                    class="group py-6 md:py-8 transition-all duration-200 hover:bg-slate-50/90 px-4 sm:px-6 rounded-2xl cursor-pointer">
                    <div class="grid grid-cols-1 lg:grid-cols-12 gap-4 items-center">
                        <!-- Left: Title and Green Dash Indicator -->
                        <div class="lg:col-span-6 space-y-2">
                            <h3
                                class="text-lg sm:text-xl font-bold text-gray-900 group-hover:text-emerald-700 transition-colors leading-snug">
                                {{ job.title }}
                            </h3>
                            <div class="text-emerald-500 font-bold text-xl leading-none select-none">-</div>
                        </div>

                        <!-- Center: Department -->
                        <div class="lg:col-span-3 space-y-1">
                            <p class="text-xs uppercase tracking-wider text-gray-400 font-semibold">Departemen</p>
                            <p class="text-sm md:text-base font-bold text-gray-900">
                                {{ job.department }}
                            </p>
                        </div>

                        <!-- Right: Location -->
                        <div class="lg:col-span-3 space-y-1 lg:text-left">
                            <p class="text-xs uppercase tracking-wider text-gray-400 font-semibold">Lokasi</p>
                            <p class="text-sm md:text-base font-bold text-gray-900">
                                {{ job.location }}
                            </p>
                        </div>
                    </div>
                </div>

                <!-- Empty state -->
                <div *ngIf="filteredJobs.length === 0" class="text-center py-16 space-y-4">
                    <div
                        class="w-16 h-16 mx-auto rounded-full bg-gray-100 text-gray-400 flex items-center justify-center">
                        <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z">
                            </path>
                        </svg>
                    </div>
                    <h4 class="text-lg font-bold text-gray-800">Tidak ada lowongan yang sesuai</h4>
                    <p class="text-gray-500 text-sm max-w-md mx-auto">
                        Coba sesuaikan kata kunci pencarian atau ubah filter departemen dan lokasi di atas.
                    </p>
                    <button (click)="selectedDepartment = 'all'; selectedLocation = 'all'; searchQuery = ''"
                        class="px-6 py-2.5 rounded-full bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-bold shadow-md hover:shadow-lg transition cursor-pointer">
                        Tampilkan Semua Lowongan
                    </button>
                </div>
            </div>
        </div>
    </section>
</div>

<!-- ========================================== -->
<!-- 2. HALAMAN DETAIL LOWONGAN (DETAIL VIEW)   -->
<!-- ========================================== -->
<div *ngIf="currentJobDetail" class="bg-white min-h-screen">
    <!-- Breadcrumb & Back Navigation -->
    <div class="bg-gray-50 border-b border-gray-200 py-4">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <button (click)="backToJobList()"
                class="inline-flex items-center gap-2 text-sm font-semibold text-gray-600 hover:text-emerald-700 transition-colors cursor-pointer group">
                <svg class="w-4 h-4 transform group-hover:-translate-x-1 transition-transform" fill="none"
                    stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
                </svg>
                <span>Kembali ke Semua Lowongan</span>
            </button>
        </div>
    </div>

    <!-- Main Detail Layout (2 Columns inspired by GoTo) -->
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-16">
        <div class="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
            <!-- Left / Main Column: Job Description & Details -->
            <div class="lg:col-span-8 space-y-10">
                <!-- Job Title & Top Apply Button -->
                <div class="space-y-6">
                    <div class="space-y-2">
                        <h1 class="text-2xl sm:text-3xl md:text-4xl font-extrabold text-gray-900 leading-tight">
                            {{ currentJobDetail.title }}
                        </h1>
                    </div>

                    <!-- Role Overview -->
                    <p class="text-gray-700 text-base md:text-lg leading-relaxed pt-2">
                        {{ currentJobDetail.description }}
                    </p>
                </div>

                <hr class="border-gray-200">

                <!-- Section: What You Will Do -->
                <div class="space-y-4">
                    <h2 class="text-xl sm:text-2xl font-bold text-gray-900">
                        What You Will Do
                    </h2>
                    <ul class="space-y-3 text-gray-700 text-sm sm:text-base leading-relaxed">
                        <li *ngFor="let item of currentJobDetail.responsibilities" class="flex items-start gap-3">
                            <span class="w-2 h-2 rounded-full bg-emerald-600 mt-2 flex-shrink-0"></span>
                            <span>{{ item }}</span>
                        </li>
                    </ul>
                </div>

                <hr class="border-gray-200">

                <!-- Section: What You Will Need -->
                <div class="space-y-4">
                    <h2 class="text-xl sm:text-2xl font-bold text-gray-900">
                        What You Will Need
                    </h2>
                    <ul class="space-y-3 text-gray-700 text-sm sm:text-base leading-relaxed">
                        <li *ngFor="let item of currentJobDetail.requirements" class="flex items-start gap-3">
                            <span class="w-2 h-2 rounded-full bg-emerald-600 mt-2 flex-shrink-0"></span>
                            <span>{{ item }}</span>
                        </li>
                    </ul>
                </div>

                <hr class="border-gray-200">

                <!-- Section: Benefit & Fasilitas -->
                <div class="space-y-4">
                    <h2 class="text-xl sm:text-2xl font-bold text-gray-900">
                        Benefit & Fasilitas yang Anda Dapatkan
                    </h2>
                    <ul class="space-y-3 text-gray-700 text-sm sm:text-base leading-relaxed">
                        <li *ngFor="let item of currentJobDetail.benefits" class="flex items-start gap-3">
                            <span class="w-2 h-2 rounded-full bg-teal-600 mt-2 flex-shrink-0"></span>
                            <span>{{ item }}</span>
                        </li>
                    </ul>
                </div>

                <hr class="border-gray-200">

                <!-- Section: About The Team -->
                <div class="space-y-3">
                    <h2 class="text-xl sm:text-2xl font-bold text-gray-900">
                        About The Team
                    </h2>
                    <p class="text-gray-700 text-sm sm:text-base leading-relaxed">
                        {{ currentJobDetail.aboutTheTeam }}
                    </p>
                </div>

                <hr class="border-gray-200">

                <!-- Section: About Visidea Studio -->
                <div class="space-y-3">
                    <h2 class="text-xl sm:text-2xl font-bold text-gray-900">
                        About Visidea Studio
                    </h2>
                    <p class="text-gray-700 text-sm sm:text-base leading-relaxed">
                        {{ currentJobDetail.aboutVisidea }}
                    </p>
                </div>

                <!-- Recruitment Disclaimer -->
                <div
                    class="bg-gray-50 rounded-2xl p-5 sm:p-6 border border-gray-200 text-xs sm:text-sm text-gray-600 leading-relaxed space-y-2">
                    <p class="font-bold text-gray-800">Pemberitahuan Resmi Rekrutmen Visidea Studio:</p>
                    <p>
                        Visidea Studio hanya mempublikasikan lowongan pekerjaan resmi melalui website resmi kami dan
                        kanal media sosial terverifikasi. Kami tidak pernah memungut biaya apapun dalam seluruh proses
                        rekrutmen. Waspadalah terhadap segala bentuk penipuan yang mengatasnamakan Visidea Studio.
                    </p>
                </div>


            </div>

            <!-- Right Column: Sidebar Meta Information (Matching GoTo format) -->
            <div class="lg:col-span-4">
                <div class="sticky top-28 bg-gray-50 rounded-3xl p-6 sm:p-8 border border-gray-200 space-y-6">
                    <!-- Tag badge -->
                    <div class="text-xs font-mono font-bold text-emerald-800">
                        #LI-ONSITE #EVENT-CREW
                    </div>

                    <!-- Meta: Departemen -->
                    <div class="space-y-1">
                        <p class="text-xs uppercase tracking-wider text-gray-400 font-semibold">Departemen</p>
                        <p class="text-base sm:text-lg font-bold text-gray-900">
                            {{ currentJobDetail.department }}
                        </p>
                    </div>

                    <!-- Meta: Lokasi -->
                    <div class="space-y-1">
                        <p class="text-xs uppercase tracking-wider text-gray-400 font-semibold">Lokasi</p>
                        <p class="text-base sm:text-lg font-bold text-gray-900">
                            {{ currentJobDetail.location }}
                        </p>
                    </div>

                    <!-- Meta: Tipe & Waktu -->
                    <div class="space-y-1">
                        <p class="text-xs uppercase tracking-wider text-gray-400 font-semibold">Tipe Pekerjaan & Jadwal
                        </p>
                        <p class="text-sm font-semibold text-gray-900">
                            {{ currentJobDetail.type }}
                        </p>
                        <p class="text-xs text-gray-500">
                            {{ currentJobDetail.eventDate }}
                        </p>
                    </div>

                    <!-- Meta: Kompensasi -->
                    <div class="space-y-1">
                        <p class="text-xs uppercase tracking-wider text-gray-400 font-semibold">Kompensasi</p>
                        <p class="text-sm font-bold text-emerald-700">
                            {{ currentJobDetail.compensation }}
                        </p>
                    </div>

                    <!-- Sidebar Actions (Solid Green + Solid Blue Palette) -->
                    <div class="pt-4 space-y-3">
                        <button (click)="openApplyModal(currentJobDetail)"
                            class="w-full inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-sm shadow-md hover:shadow-lg transition-all cursor-pointer">
                            <span>Lamar pekerjaan ini</span>
                        </button>
                        <button (click)="applyViaWhatsApp(currentJobDetail, $event)"
                            class="w-full inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full bg-[#102B51] hover:bg-[#163564] text-white font-bold text-sm shadow-md hover:shadow-lg transition-all cursor-pointer">
                            <img src="/assets/visidea/whatsapp.png" class="w-4 h-4 brightness-0 invert" alt="WhatsApp">
                            <span>Tanya via WhatsApp</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- ========================================== -->
<!-- 3. MODAL: FORMULIR LAMARAN PEKERJAAN       -->
<!-- ========================================== -->
<div *ngIf="isApplyModalOpen && currentJobDetail"
    class="fixed inset-0 z-[100] flex items-center justify-center p-4 overflow-y-auto">
    <!-- Backdrop Blur -->
    <div (click)="closeApplyModal()" class="fixed inset-0 bg-black/60 backdrop-blur-sm transition-opacity"></div>

    <!-- Modal Form Content Box -->
    <div
        class="relative bg-white rounded-3xl max-w-2xl w-full max-h-[90vh] overflow-y-auto shadow-2xl z-10 border border-gray-100 p-6 sm:p-8 animate-scale-in">
        <!-- Close Button -->
        <button (click)="closeApplyModal()"
            class="absolute top-5 right-5 w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-600 flex items-center justify-center transition-all cursor-pointer">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
        </button>

        <div class="space-y-6">
            <!-- Header -->
            <div class="space-y-1">
                <span class="inline-block px-3 py-1 rounded-full bg-emerald-100 text-emerald-800 text-xs font-bold">
                    Formulir Lamaran
                </span>
                <h3 class="text-xl sm:text-2xl font-extrabold text-[#102B51]">
                    {{ currentJobDetail.title }}
                </h3>
                <p class="text-xs sm:text-sm text-gray-500">
                    Isi data diri Anda di bawah ini untuk memulai proses seleksi tim Visidea Studio.
                </p>
            </div>

            <!-- Form -->
            <form (ngSubmit)="submitApplication()" class="space-y-4">
                <div>
                    <label class="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-1">Nama Lengkap
                        *</label>
                    <input type="text" [(ngModel)]="applicationForm.fullName" name="fullName" required
                        placeholder="Masukkan nama lengkap Anda"
                        class="w-full px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:bg-white focus:border-emerald-500 focus:ring-2 focus:ring-emerald-200 outline-none transition">
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-1">No. WhatsApp
                            Aktif *</label>
                        <input type="tel" [(ngModel)]="applicationForm.whatsapp" name="whatsapp" required
                            placeholder="Contoh: 08123456789"
                            class="w-full px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:bg-white focus:border-emerald-500 focus:ring-2 focus:ring-emerald-200 outline-none transition">
                    </div>
                    <div>
                        <label class="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-1">Email</label>
                        <input type="email" [(ngModel)]="applicationForm.email" name="email"
                            placeholder="email@domain.com"
                            class="w-full px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:bg-white focus:border-emerald-500 focus:ring-2 focus:ring-emerald-200 outline-none transition">
                    </div>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-1">Akun Instagram</label>
                        <input type="text" [(ngModel)]="applicationForm.instagram" name="instagram"
                            placeholder="@username"
                            class="w-full px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:bg-white focus:border-emerald-500 focus:ring-2 focus:ring-emerald-200 outline-none transition">
                    </div>
                    <div>
                        <label class="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-1">Upload CV / Resume (PDF/DOC)</label>
                        <div class="relative">
                            <input type="file" (change)="onFileSelected($event)" accept=".pdf,.doc,.docx,.png,.jpg,.jpeg"
                                class="hidden" id="cvFileInput">
                            <label for="cvFileInput"
                                class="w-full px-4 py-2.5 bg-gray-50 hover:bg-gray-100 border border-dashed border-emerald-500 rounded-xl text-sm text-gray-700 flex items-center justify-between cursor-pointer transition">
                                <span class="truncate">{{ selectedCvFileName || 'Pilih File CV...' }}</span>
                                <span class="text-xs font-bold text-emerald-700 bg-emerald-100 px-2 py-1 rounded-md">Browse</span>
                            </label>
                        </div>
                    </div>
                </div>

                <div>
                    <label class="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-1">Pengalaman Event
                        / Fotografi / Organisasi</label>
                    <textarea [(ngModel)]="applicationForm.experience" name="experience" rows="2"
                        placeholder="Ceritakan pengalaman relevan Anda secara singkat..."
                        class="w-full px-4 py-2 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:bg-white focus:border-emerald-500 focus:ring-2 focus:ring-emerald-200 outline-none transition"></textarea>
                </div>

                <div>
                    <label class="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-1">Motivasi
                        Bergabung</label>
                    <textarea [(ngModel)]="applicationForm.motivation" name="motivation" rows="2"
                        placeholder="Mengapa Anda tertarik dengan posisi ini di Visidea Studio?"
                        class="w-full px-4 py-2 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:bg-white focus:border-emerald-500 focus:ring-2 focus:ring-emerald-200 outline-none transition"></textarea>
                </div>

                <div class="pt-3 flex items-center justify-end gap-3">
                    <button type="button" (click)="closeApplyModal()"
                        class="px-5 py-2.5 rounded-xl border border-gray-300 text-gray-700 font-semibold text-sm hover:bg-gray-50 transition cursor-pointer">
                        Batal
                    </button>
                    <button type="submit" [disabled]="isSubmitting"
                        class="px-7 py-2.5 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-sm shadow-md hover:shadow-lg transition-all flex items-center gap-2 cursor-pointer disabled:opacity-50">
                        <span *ngIf="!isSubmitting">Kirim Lamaran Sekarang</span>
                        <span *ngIf="isSubmitting">Mengirim...</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>